import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {BlockElementButton} from 'app/entities/blockElements/blockElementButton';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';

@Component({
  selector: 'app-block-button-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementButtonComponent extends BlockElementAbstractComponent<BlockElementButton> {

  @HostBinding('class')
  get classes() {
    return [];
  }
}
